export var languageMap = {
    en: 'English',
    es: 'Spanish',
    both: 'English or Spanish',
};
export var classLinkText = "For this purpose please contact your school ClassLink admin. Once your class info is changed in the ClassLink portal, inform us about changes so we can sync them with your Happy Numbers account.";
export var cleverText = "For this purpose please contact your school Clever administrator or refer to the Clever Help Center. Once your class info is changed in the Clever portal it will automatically be synced with your Happy Numbers account.";
